import { getYaNative } from '@yanolja-org/ya-native';
import { useEffect, useState } from 'react';

type YaNative = ReturnType<typeof getYaNative>;

export const useYaNative = (): YaNative | undefined => {
  const [yaNative, setYaNative] = useState<YaNative>();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setYaNative(getYaNative());
    }
  }, []);

  return yaNative;
};
